import React from 'react';
import RubiksCube from './components/RubiksCube';

function App() {
  return (
    <div className="App">
      <RubiksCube />
    </div>
  );
}

export default App;
